export default __webpack_public_path__ + "static/media/mongodb-plain.3e7ca792.svg";